import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import * as Types from "./types";

export const adjustmentCreateService = (
  params: Types.AdjustmentCreateRequest
) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.POST,
    url: Paths.Create,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const adjustmentListService = (params: {
  page?: number | null;
  limit?: number | null;
  templateId?: string | null;
  employeeId?: number | null;
  employeeIds?: number[] | null;
  status?: number | null;
  month?: number | null;
  templatePeriod?: string | null;
  cycleId?: string | null;
  year?: number | null;
}) =>
  RestAPIClient.call<Types.AdjustmentListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      requireAuthentication: true,
      params,
    },
  });
